import {createContext, use} from 'react'

const LoggedInContext = createContext<boolean>(true)

export default LoggedInContext

export function useLoggedInContext() {
  return use(LoggedInContext)
}

try{ LoggedInContext.displayName ||= 'LoggedInContext' } catch {}